import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";
import { POSTER_WIDTH, POSTER_HEIGHT, TEMPLATES } from "./constants.js";
import { PosterCard } from "./PosterCard/index.jsx";

export function PosterPreviewArea({
  selectedRecipe,
  loading,
  posterRef,
  preloadedImageUrl,
  selectedTemplate,
  user,
}) {
  const { t } = useLanguage();
  const tpl = TEMPLATES.find((x) => x.id === selectedTemplate) || TEMPLATES[0];
  const ingreds = selectedRecipe?.ingredients
    ? String(selectedRecipe.ingredients)
        .split("\n")
        .filter((l) => l.trim())
        .slice(0, 4)
    : [];
  const imgUrl =
    preloadedImageUrl || selectedRecipe?.image_url || selectedRecipe?.image;

  if (!selectedRecipe) {
    return (
      <div
        className="flex items-center justify-center rounded-xl border-2 border-dashed border-white/20 bg-white/5 text-white/50 text-sm"
        style={{ width: POSTER_WIDTH, height: POSTER_HEIGHT }}
      >
        {loading ? t("loadingRecipes") : t("selectRecipeToPreview")}
      </div>
    );
  }

  return (
    <div
      ref={posterRef}
      className="rounded-xl overflow-hidden shadow-2xl shrink-0"
      style={{ width: POSTER_WIDTH, height: POSTER_HEIGHT, background: tpl.bg }}
    >
      <PosterCard
        recipe={selectedRecipe}
        imgUrl={imgUrl}
        template={tpl}
        ingredients={ingreds}
        userName={user?.first_name || user?.username}
      />
    </div>
  );
}
